import { render, staticRenderFns } from "./EmbeddedAppDelegator.vue?vue&type=template&id=77f716da&scoped=true"
import script from "./EmbeddedAppDelegator.vue?vue&type=script&lang=js"
export * from "./EmbeddedAppDelegator.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedAppDelegator.vue?vue&type=style&index=0&id=77f716da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f716da",
  null
  
)

export default component.exports